import { GetBusinessInfoResponse } from "@1games-ru/region-shared/dist/backend/requests/business";
import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";
import { IdIcon } from "@/shared/icons";
import { Location, Modal } from "@/shared/ui";
import Loader from "@/shared/ui/Loader";
import PersonalDataCard from "@/shared/widgets/PersonalDataCard";
import getBusinessImage from "@/domains/business/helpers/getBusinessImage";
import BusinessModalTitle from "@/domains/business/components/modals/BusinessModalTitle";
import BusinessModalWiew from "@/domains/business/components/modals/BusinessModalWiew";

type Props = {
  isLoading: boolean;
  info: GetBusinessInfoResponse;
  exit: () => void;
};

export default function BusinessInfoModalContainer({ isLoading, info, exit }: Props) {
  const { t } = useTranslation("business");

  const title = !isLoading ? (
    <BusinessModalTitle name={info?.name} level={t(`business.level.${info?.level}`)} />
  ) : (
    ""
  );
  const logo = info?.id ? getBusinessImage(info?.id, "logo") : "";
  const address = info?.address ? `${info?.address?.streetName} ${info?.address?.index}` : "";

  return (
    <Modal
      open
      title={title}
      onClose={exit}
      className="w-135 h-[33rem] pt-6.5 pb-7.5 pl-7.5 pr-6.5"
      classNameCloseBtn="top-6.5 right-7.5"
      dataMzAccent="lightBlue"
      style={{ fontFamily: "TT Norms Pro", boxShadow: "0px 0px 200px 0px rgba(0, 121, 194, 0.30)" }}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <BusinessModalWiew
            id={info?.id}
            isAvita={info?.isOnMarketplace}
            feeDays={info?.paidDays}
          />
          <PersonalDataCard
            id={info?.owner?.characterId}
            isOnline={!!info?.owner?.playerMpId}
            name={info?.owner?.name}
            onCall={() => {}}
            onMsg={() => {}}
          />
          <Location address={address}>
            <div
              className="relative flex w-[6.6875rem] h-6 mt-5 ml-auto"
              style={{
                backgroundImage: `url(${logo})`,
                backgroundPosition: "top right",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
              }}
            />
          </Location>
          <div className="flex items-center gap-2.5 mb-3.5 px-1 pb-4 border-solid border-b border-b-[#191919]">
            <IdIcon className="size-4.5 text-white/60" />
            <div className="flex gap-1 text-16 font-medium leading-none">
              <p className="text-white/60">{t("business.id")}:</p>
              <p>#{info?.id}</p>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-16 font-medium leading-none">{t("business.feePerDay")}:</p>
            <p className="text-16 font-medium leading-none">{formatPrice(info?.baseFee)} ₽</p>
          </div>
        </>
      )}
    </Modal>
  );
}
